import axios from 'axios'

let http = axios.create({
    baseURL: `${process.env.VUE_APP_API_ROOT_URL}/api/v1`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem('access_token')}`
    }
})

/**
 *
 * ATENÇÃO FUNÇÃO QUEBRA-GALHO ABAIXO
 *
 * Esta função tem como objetivo trocar as cores do tema baseado nas configurações do cliente,
 * porém, como não temos como saber quanto foi a última atualização ou quando o cliente estará logado
 * fazemos a execução da função duas vezes em hooks "abertos" onde não impactam na performance do aplicativo
 * cuidado ao fazer alterações nessa função
 *
 * As cores tem que ter nomes exatos que estão sendo usados nas variáveis de CSS
 */
export const setThemeColors = async (auth) => {
    let hasToken = localStorage.getItem('access_token') !== null

    if (hasToken) {
        let access_token = localStorage.getItem('access_token')
        let configuration = await getConfiguration(access_token)

        return designateColors(configuration)
    }

    if (auth) {
        let configuration = await getConfiguration(auth.access_token)
        return designateColors(configuration)
    }

    let lsColors = localStorage.getItem('colors')
    let lsImages = localStorage.getItem('images')

    if (lsColors || lsImages) {
        let colorsParsed = JSON.parse(lsColors)
        let imagesParsed = JSON.parse(lsImages)

        let theme_configs = colorsParsed.concat(imagesParsed)

        return designateColors(theme_configs)
    }

    function designateColors (config) {
        
        let colors = []
        let images = []
        
        localStorage.removeItem('colors')
        localStorage.removeItem('images')
        for ( var i in config ) {
            
            if (config[i].key.includes('color')) {
                colors.push(config[i])
                if (config[i].value && config[i].value.trim() !== '') {
                    document.documentElement.style.setProperty(`--${config[i].key.replace(/\_/gm, '-')}`, config[i].value);
                }
            }
            
            if (config[i].key.includes('logo')) {
                images.push(config[i])
                if (config[i].value && config[i].value.trim() !== '') {
                    localStorage.setItem('images', JSON.stringify(images))
                }
            }
            // FIM DO LOOP
            if (i >= Object.keys(config)) {
                localStorage.setItem('colors', JSON.stringify(colors))
            }
        }

    }

    async function getConfiguration (access_token) {
        let { data } = await http.get(`/configuration`, { headers: { Authorization: `Bearer ${access_token}` } })
        return data
    }

}